<h3 class="cx-checkout-title d-none d-lg-block d-xl-block pt-4">
  {{ 'checkoutProgress.deliveryMode' | cxTranslate }}
</h3>

@if (!(isUpdating$ | async)) {
  <div role="status" [attr.aria-label]="'common.loaded' | cxTranslate"></div>
  <div [formGroup]="mode">
    <div class="atg-mode-list">
      @for (method of shippingMethods; track method) {
        <div class="atg-mode-row">
          <input
            [attr.aria-checked]="getAriaChecked(method.code)"
            class="atg-radio"
            role="radio"
            type="radio"
            id="deliveryMode-{{ method.code }}"
            (change)="changeMode(method.code)"
            [value]="method.code"
            formControlName="deliveryModeId"
            />
          <label class="atg-method-name" for="deliveryMode-{{ method.code }}">
            {{ method.name }}
          </label>
          <div class="atg-collect-area" [formGroup]="collectForm">
            @if (selectedCode === method.code && method.collectRequired) {
              <div class="atg-collect-field">
                <div class="atg-collect-input-wrap">
                  <input
                    type="text"
                    class="form-control atg-collect-input"
                    [id]="'collect-' + method.code"
                    [formControlName]="method.code"
                    [placeholder]="getCollectPlaceholder(method.code)"
                    />
                  <span class="text-danger font-size-18 atg-required-badge" aria-hidden="true">*</span>
                </div>
                @if (getCollectControl(method.code).invalid && getCollectControl(method.code).touched) {
                  <div
                    class="atg-collect-error"
                    >
                    {{
                      (isFedexGround(method.code, method.name)
                        ? 'checkoutShipping.collectNumberFedexError'
                        : 'checkoutShipping.collectNumberDefaultError'
                      ) | cxTranslate
                    }}
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="row cx-checkout-btns">
      <div class="col-md-12 col-lg-6">
        <button class="btn btn-block btn-action" (click)="back()">
          {{ backBtnText | cxTranslate }}
        </button>
      </div>
      <div class="col-md-12 col-lg-6">
        <button
          class="btn btn-block btn-primary"
          [disabled]="deliveryModeInvalid || collectNumberInvalid"
          (click)="next()"
          >
          {{ 'common.continue' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}

